import { VerticalLayout } from "ds_legacy/materials/layouts";
import { padding } from "ds_legacy/materials/metrics";
import {
  DatePickerWithLabel,
  Footnote,
  FootnoteDescription,
  FootnoteLabel,
  GAP,
  Section,
  SectionRow,
  TextInputWithLabel,
} from "dsl/ecosystems/PatientForms/components";
import { useTranslations } from "translations";
import Translations from "translations/types";

const FOOTNOTE: Footnote = {
  description: (translations: Translations) =>
    translations.patientForms.transitionalCareForm.contactInformation
      .footnoteInsuranceNumber,
  label: (translations: Translations) =>
    translations.patientForms.transitionalCareForm.contactInformation
      .patientInsuranceNumber,
  superText: 1,
};

export const PatientContactSection = () => {
  const translations = useTranslations();
  return (
    <Section
      title={
        translations.patientForms.transitionalCareForm.contactInformation
          .titlePatient
      }
    >
      <SectionRow>
        <TextInputWithLabel
          bold
          elementName="patient_last_name"
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .patientName
          }
          large
        />
        <TextInputWithLabel
          bold
          elementName="patient_first_name"
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .patientFirstName
          }
          large
        />
        <DatePickerWithLabel
          bold
          disableFuture
          elementName="patient_date_of_birth"
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .patientBirthDate
          }
        />
      </SectionRow>

      <SectionRow>
        <TextInputWithLabel
          bold
          elementName="patient_insurance_number"
          label={<FootnoteLabel footnote={FOOTNOTE} />}
          large
        />
        <TextInputWithLabel
          bold
          elementName="patient_location_street"
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .patientStreet
          }
          large
        />
        <TextInputWithLabel
          bold
          elementName="patient_location_house_number"
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .patientStreetNumber
          }
        />
      </SectionRow>
      <SectionRow>
        <TextInputWithLabel
          bold
          elementName="patient_location_zipcode"
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .patientZipCode
          }
        />
        <TextInputWithLabel
          bold
          elementName="patient_location_city"
          label={
            translations.patientForms.transitionalCareForm.contactInformation
              .patientCity
          }
          large
        />
      </SectionRow>
      <VerticalLayout
        style={{
          boxSizing: "border-box",
          padding: padding(GAP, 0, 0),
        }}
      >
        <FootnoteDescription footnote={FOOTNOTE} />
      </VerticalLayout>
    </Section>
  );
};
